import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HomeHero, HomeUniverses, HomeAudience } from "@/components/home/HomeTop";
import { HomeIncome } from "@/components/home/HomeIncome";
import { HomeWhy, HomeAdvantages, HomeProducts, HomeBrand, HomeFinalCta } from "@/components/home/HomeBottom";
import { useSeo, useJsonLd, SITE_URL } from "@/lib/seo";

const OLD_ANCHORS = ["#packs", "#how", "#who", "#avis", "#faq", "#gamme", "#comparatif"];

export default function ProHome() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  useEffect(() => { if (OLD_ANCHORS.includes(hash)) navigate(`/packs${hash}`, { replace: true }); }, [hash, navigate]);
  useSeo({
    title: "Ozentya | Produits de coiffure professionnels, afro et barber shop",
    description: "Ozentya, la plateforme des professionnels de la coiffure afro, européenne et des barbershops : produits professionnels à prix HT, livraison en France. Créez votre compte pro.",
    path: "/",
    image: `${SITE_URL}/img/home/pro-hero.webp`,
  });
  useJsonLd("ld-organization", {
    "@context": "https://schema.org", "@type": "Organization", name: "Ozentya", url: SITE_URL,
    logo: `${SITE_URL}/logo192.png`,
    description: "Plateforme de produits de coiffure professionnels pour salons afro, salons de coiffure européenne et barbershops en France.",
    sameAs: ["https://instagram.com/ozentya_pousse_cheveux", "https://www.tiktok.com/@ozentyapoussecheveu"],
  });
  useJsonLd("ld-website", { "@context": "https://schema.org", "@type": "WebSite", name: "Ozentya", url: SITE_URL, inLanguage: "fr-FR" });
  return (
    <div data-testid="pro-home">
      <HomeHero />
      <HomeIncome />
      <HomeUniverses />
      <HomeAudience />
      <HomeWhy />
      <HomeAdvantages />
      <HomeProducts />
      <HomeBrand />
      <HomeFinalCta />
    </div>
  );
}
